import { Link } from "react-router-dom";

const links = [
    { to: "/privacy", label: "Privacy Policy", testId: "footer-privacy-link" },
    { to: "/cookie-policy", label: "Cookie Policy", testId: "footer-cookie-link" },
    { to: "/termini", label: "Termini e condizioni", testId: "footer-terms-link" },
    { to: "/contatti", label: "Contatti", testId: "footer-contatti-link" },
];

export const Footer = () => (
    <footer id="contatti" className="bg-navy-950 pb-24 md:pb-0">
        <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
            <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                <nav className="flex flex-wrap items-center gap-x-1 gap-y-2">
                    {links.map((l, i) => (
                        <span key={l.to} className="flex items-center">
                            <Link
                                to={l.to}
                                data-testid={l.testId}
                                className="text-xs font-medium text-slate-300 transition-colors duration-300 hover:text-gold"
                            >
                                {l.label}
                            </Link>
                            {i < links.length - 1 && <span className="mx-3 h-3 w-px bg-white/20" />}
                        </span>
                    ))}
                </nav>
                <p className="max-w-sm text-[11px] leading-relaxed text-slate-500 md:text-right">
                    Materiale didattico indipendente. Non affiliato a enti pubblici né al Ministero della Difesa.
                </p>
            </div>
            <div className="mt-6 border-t border-white/10 pt-5 text-center text-[11px] leading-relaxed text-slate-600">
                <p>Proaura s.r.l.s. · P.IVA 17045531005 · Sede legale: Via dei Casali Molinario 3, 00189 Roma (RM)</p>
                <p className="mt-1.5">
                    © {new Date().getFullYear()} Preparazione Concorsi — Difesa AMM 2026, 3 Simulazioni Complete. Tutti
                    i diritti riservati.
                </p>
            </div>
        </div>
    </footer>
);
